import React, { useState } from 'react';
import Step1New from './step1New';
import Step2Details from './Step2Details';
import Step3Medias from './Step3Medias';
import Step4Features from './Step4Features';
import Step5Preview from './Step5Preview';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { showToast } from '../../../../components/common/notification/Notification';
import { useNavigate } from "react-router-dom";

const PropertyForm = () => {
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.auth.user);
  const assetUrl = process.env.REACT_APP_ASSET_URL;
  // const token = loggedInUser?.token; 
  const token = loggedInUser?.refreshToken; 
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [step, setStep] = useState(1);
  const [propertyForm, setPropertyForm] = useState({});

  const steps = [
    { title: 'New' },
    { title: 'Details' },
    { title: 'Medias' },
    { title: 'Features' },
    { title: 'Preview' },
  ];


  const BUY_PURPOSE_ID = 1; // buy id

  const handleNext = () => {
    if (
      step === 2 &&
      propertyForm.propertyPurpose === BUY_PURPOSE_ID &&
      (!propertyForm.images || propertyForm.images.length === 0)
    ) {
      setStep(4); // Skip medias
    } else if (step < steps.length) {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  // Step 5: Update button handler
  const handleUpdate = () => {
    setStep(1);
    // propertyForm already has all data, so Step 1 will be pre-filled
  };

  // Step 5: Submit button handler
  const handleSubmit = async () => { 
    let images = (propertyForm.images || []).map((img) => ({
      image_url: (img.url || "").replace(assetUrl, ""),
    }));

    const videos = (propertyForm.videos || []).map((video) => ({
      name: video.name || null,
      description: null,
      url_path: (video.url || "").replace(assetUrl, ""),
    })); 

    const attachments = (propertyForm.attachments || []).map((a) => ({
      name: a.name || null,
      attachment_url: (a.url || "").replace(assetUrl, ""),
    }));
    console.log('propertyForm', propertyForm)  
    // console.log("attachments", attachments)
 
    const payload = {
      city_name: propertyForm.cityName || '',
      state_name: propertyForm.stateName || '',
      country_name: "India",
      area_name: propertyForm.area || '',
      property_type_id: propertyForm.propertyType || null,      
      purpose_id: propertyForm.propertyPurpose || null,
      property_status_id: 5,
      sub_type_id: propertyForm.propertySubtype || null,        
      structure: propertyForm.structure || {},                  
      feature: propertyForm.feature || {},                      
      images,
      videos,
      attachments, 
      tags: propertyForm.tags || '',
      name: propertyForm.name || '',
      description: propertyForm.description || '',
      address: propertyForm.address || '',
      land_mark: propertyForm.land_mark || '',
      pin_code: propertyForm.pin_code || '',
      price: propertyForm.price || '', 
      land_type_id: propertyForm.landType || null,              
      loan_availability: propertyForm.loanAvailability,
      are: propertyForm.are || '',
      sub_sub_type_id: propertyForm.propertySubSubType || null, 
      lead_id: 0,
      active: true, 
      featured_property: propertyForm.featured_property,
    };

    try {
      console.log("Submitting payload:", payload);

      const response = await axios.post(`${baseUrl}/property/addProperty`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.statusType === 'SUCCESS') {
        console.log('hii toast appeared')
        showToast('Property added successfully' , { type: 'success' });
        setTimeout(() => {
          navigate("/property");
        }, 2000);
      } else {
        showToast('Failed to Submit Property data', { type: 'error' });
      }
      console.log("Response:", response.data);

    } catch (error) {
      showToast('Failed to Submit Property data', { type: 'error' });
      console.error("Error submitting property form:", error);
    }
  };

  const renderStepComponent = () => {
    switch (step) {
      case 1:
        return <Step1New form={propertyForm} setForm={setPropertyForm} nextStep={handleNext} />;
      case 2:
        return <Step2Details form={propertyForm} setForm={setPropertyForm} nextStep={handleNext} prevStep={handleBack} />;
      case 3:
        return (
          <Step3Medias 
            form={propertyForm}
            setForm={setPropertyForm}
            nextStep={handleNext}
            prevStep={handleBack}
          />
        );
      case 4:
        return (
          <Step4Features
            form={propertyForm}
            setForm={setPropertyForm}
            nextStep={handleNext}
            prevStep={handleBack}
          />
        );
      case 5:
        return (
          <div>
            <Step5Preview 
              form={propertyForm} 
              prevStep={handleBack} 
              onUpdate={handleUpdate} 
              onSubmit={handleSubmit}
            />
          </div>
        );
      default:
        return null;
    }
  };

  const progressPercent = ((step - 1) / (steps.length - 1)) * 100;

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Create New Property</h2>

      <div className="progress mb-4">
        <div className="progress-bar" style={{ width: `${progressPercent}%` }}>
          Step {step} of {steps.length}
        </div>
      </div>

      <div className="card p-4">
        {renderStepComponent()}
      </div>
    </div>
  );
};

export default PropertyForm;